// Shared REST helper.
//
// WordPress only applies the auth cookie to a REST request that carries a
// wp_rest nonce - rest_cookie_check_errors() calls wp_set_current_user(0)
// when the header is missing, so a request from a logged-in admin without it
// is treated as anonymous and 401s on any route with a capability check.
//
// The nonce comes from whichever screen we're on. Every source below except
// wpApiSettings is localised by this plugin, so it is there whenever our
// script is:
//
//   apiConfig      passed down as a prop by the post-type meta boxes
//   casData        localised on the CAS admin pages
//   casBlockData   localised on the block editor script
//   wpApiSettings  core's, and only a fallback - core attaches it to
//                  wp-api-request when WP_Scripts is first built after
//                  `init`, so anything that touches the script registry
//                  earlier leaves it undefined

export const getRestNonce = (apiConfig) =>
  apiConfig?.nonce ||
  window.casData?.nonce ||
  window.casBlockData?.nonce ||
  window.wpApiSettings?.nonce ||
  '';

/**
 * fetch() with the credentials and nonce a WordPress REST call needs.
 *
 * @param {string} url
 * @param {object} options       Standard fetch options.
 * @param {object} [apiConfig]   Optional { nonce } from a meta box.
 * @returns {Promise<Response>}
 */
export const casFetch = (url, options = {}, apiConfig = undefined) => {
  const nonce = getRestNonce(apiConfig);

  if (!nonce) {
    // Better to send nothing than an empty header: WordPress answers a blank
    // nonce with rest_cookie_invalid_nonce, which reads like the nonce is
    // wrong rather than missing.
    console.warn('[CAS] No wp_rest nonce available; REST call will be anonymous:', url);
  }

  return fetch(url, {
    credentials: 'same-origin',
    ...options,
    headers: {
      ...(nonce ? { 'X-WP-Nonce': nonce } : {}),
      ...(options.headers || {}),
    },
  });
};

export default casFetch;
